export type BrandType = 'web.de' | 'gmx.net' | 'gmx.at'

let brandName: BrandType = 'web.de'
// for testing:
// let brandName: BrandType = 'gmx.net'

const host = location.hostname.split('.').slice(1).join('.')

/* istanbul ignore next if */
if (host === 'gmx.net' || host === 'gmx.at') {
  brandName = host
}

export function getBrand(): BrandType {
  return brandName
}
